"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const winston_transport_1 = __importDefault(require("winston-transport"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const vars_1 = __importDefault(require("../config/vars"));
class TecmaTransport extends winston_transport_1.default {
    log(info, callback) {
        setImmediate(() => {
            this.emit('logged', info);
        });
        const { message } = info;
        const jwt = js_cookie_1.default.get('jwt');
        const body = {
            error: message,
            host: window.location.href,
            jwt,
            title: document.title,
            url: 'null',
        };
        fetch(vars_1.default.errorApiEndpoint, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        }).catch((e) => console.error(e));
        callback();
    }
}
exports.default = TecmaTransport;
